import React from 'react';
import { ShowerHead, Filter, DropletOff } from 'lucide-react';

/**
 * Компонент с параметрами обслуживания бассейна
 */
const MaintenanceSection = ({ 
  formData, 
  handleInputChange, 
  errors,
  waterTypes,
  filterSystems
}) => {
  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <ShowerHead className="w-5 h-5 mr-2 text-green-500" />
        Система обслуживания
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Система очистки воды */}
        <div>
          <label htmlFor="waterType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            <DropletOff className="w-4 h-4 inline-block mr-1" />
            Система очистки воды
          </label>
          <select
            id="waterType"
            name="waterType"
            value={formData.waterType}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {waterTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {formData.waterType === 'chlorine' ? 'Традиционная и широко распространенная в России' : 
             formData.waterType === 'salt' ? 'Более комфортная, но дороже в установке' :
             formData.waterType === 'bromine' ? 'Подходит для закрытых и SPA бассейнов' : 
             formData.waterType === 'ozone' ? 'Экологичная система без химии' : 
             'Дополнительная очистка для снижения расхода химии'}
          </p>
        </div>
        
        {/* Система фильтрации */}
        <div>
          <label htmlFor="filterSystem" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            <Filter className="w-4 h-4 inline-block mr-1" />
            Система фильтрации
          </label>
          <select
            id="filterSystem"
            name="filterSystem"
            value={formData.filterSystem}
            onChange={handleInputChange}
            className="form-select w-full"
          >
            {filterSystems.map((system) => (
              <option key={system.id} value={system.id}>
                {system.name}
              </option>
            ))}
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {formData.filterSystem === 'sand' ? 'Доступное решение, широко используется в России' : 
             formData.filterSystem === 'cartridge' ? 'Простая замена картриджей, занимает мало места' :
             'Наиболее эффективная фильтрация, долгий срок службы'}
          </p>
        </div>
        
        {/* Уровень обслуживания */}
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Уровень обслуживания
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <label className={`
              relative p-3 rounded-lg border cursor-pointer transition-colors
              ${formData.maintenanceLevel === 'basic' 
                ? 'bg-green-100 dark:bg-green-900/30 border-green-500 dark:border-green-600' 
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'}
            `}>
              <input
                type="radio"
                name="maintenanceLevel"
                value="basic"
                checked={formData.maintenanceLevel === 'basic'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <span className={`block text-sm font-medium mb-1 ${
                formData.maintenanceLevel === 'basic' 
                  ? 'text-green-700 dark:text-green-300' 
                  : 'text-gray-700 dark:text-gray-300'
              }`}>
                Базовый
              </span>
              <span className={`block text-xs ${
                formData.maintenanceLevel === 'basic' 
                  ? 'text-green-600 dark:text-green-400' 
                  : 'text-gray-500 dark:text-gray-400'
              }`}>
                Минимальное регулярное обслуживание, редкая замена воды
              </span>
            </label>
            
            <label className={`
              relative p-3 rounded-lg border cursor-pointer transition-colors
              ${formData.maintenanceLevel === 'standard' 
                ? 'bg-green-100 dark:bg-green-900/30 border-green-500 dark:border-green-600' 
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'}
            `}>
              <input
                type="radio"
                name="maintenanceLevel"
                value="standard"
                checked={formData.maintenanceLevel === 'standard'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <span className={`block text-sm font-medium mb-1 ${
                formData.maintenanceLevel === 'standard' 
                  ? 'text-green-700 dark:text-green-300' 
                  : 'text-gray-700 dark:text-gray-300'
              }`}>
                Стандартный
              </span>
              <span className={`block text-xs ${
                formData.maintenanceLevel === 'standard' 
                  ? 'text-green-600 dark:text-green-400' 
                  : 'text-gray-500 dark:text-gray-400'
              }`}>
                Регулярная проверка химии, очистка, сезонное обслуживание
              </span>
            </label>
            
            <label className={`
              relative p-3 rounded-lg border cursor-pointer transition-colors
              ${formData.maintenanceLevel === 'premium' 
                ? 'bg-green-100 dark:bg-green-900/30 border-green-500 dark:border-green-600' 
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'}
            `}>
              <input
                type="radio"
                name="maintenanceLevel"
                value="premium"
                checked={formData.maintenanceLevel === 'premium'}
                onChange={handleInputChange}
                className="sr-only"
              />
              <span className={`block text-sm font-medium mb-1 ${
                formData.maintenanceLevel === 'premium' 
                  ? 'text-green-700 dark:text-green-300' 
                  : 'text-gray-700 dark:text-gray-300'
              }`}>
                Премиум
              </span>
              <span className={`block text-xs ${
                formData.maintenanceLevel === 'premium' 
                  ? 'text-green-600 dark:text-green-400' 
                  : 'text-gray-500 dark:text-gray-400'
              }`}>
                Автоматический контроль параметров, частая замена воды
              </span>
            </label>
          </div>
        </div>
      </div>
      
      {/* Информация о стоимости обслуживания */}
      <div className="mt-6 pt-4 border-t border-green-200 dark:border-green-700">
        <h4 className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-2">
          Ориентировочная стоимость обслуживания в России
        </h4>
        <div className="overflow-x-auto rounded-lg border border-green-200 dark:border-green-700">
          <table className="min-w-full divide-y divide-green-200 dark:divide-green-700">
            <thead className="bg-green-100 dark:bg-green-800/30">
              <tr>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-green-700 dark:text-green-300 uppercase tracking-wider">
                  Тип услуги
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-green-700 dark:text-green-300 uppercase tracking-wider">
                  Периодичность
                </th>
                <th scope="col" className="px-3 py-2 text-left text-xs font-medium text-green-700 dark:text-green-300 uppercase tracking-wider">
                  Стоимость
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-green-200 dark:divide-green-700">
              <tr>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  Химия для бассейна
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  Ежемесячно
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  1000-2000 ₽/м³/год
                </td>
              </tr>
              <tr className="bg-green-50 dark:bg-green-900/10">
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  Замена воды
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  1-2 раза в год
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  40-60 ₽/м³
                </td>
              </tr>
              <tr>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  Замена фильтрующих элементов
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  {formData.filterSystem === 'sand' ? 'Раз в 5-7 лет' : 
                   formData.filterSystem === 'cartridge' ? 'Раз в 1-2 года' : 
                   'Раз в 7-10 лет'}
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  {formData.filterSystem === 'sand' ? '5000-10000 ₽' : 
                   formData.filterSystem === 'cartridge' ? '1500-4000 ₽' : 
                   '15000-25000 ₽'}
                </td>
              </tr>
              <tr className="bg-green-50 dark:bg-green-900/10">
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  Профессиональное обслуживание
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  Ежемесячно
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  5000-15000 ₽/месяц
                </td>
              </tr>
              <tr>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-700 dark:text-gray-300">
                  Электроэнергия для насоса
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  Ежемесячно
                </td>
                <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-600 dark:text-gray-400">
                  500-1500 ₽/месяц
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
          * Цены указаны для Московской области и Центрального региона России. В других регионах цены могут отличаться.
        </p>
      </div>
    </div>
  );
};

export default MaintenanceSection;